import { Directive, HostListener, input, inject } from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';

@Directive({ selector: '[tdCopy]' })
export class TdCopyDirective {
  private _clipboard = inject(Clipboard);

  readonly sourceElement = input<HTMLElement>(undefined);
  readonly copyClass = input<string>(undefined);
  readonly timeout = input<number>(undefined);
  readonly copyDisabled = input<boolean>(undefined);

  private defaultTimeout = 500;

  get _timeout() {
    return this.timeout() || this.defaultTimeout;
  }

  get _copyClass(){
    return this.copyClass() || 'copied';
  }


  @HostListener('click')
  onClick(){
    if (!this.copyDisabled()) {
      const sourceElement = this.sourceElement();
      this._clipboard.copy(
        sourceElement.innerText.trim()
      )
      sourceElement.classList.add(this._copyClass);
      setTimeout(() => {
        this.sourceElement().classList.remove(this._copyClass);
      }, this._timeout);
    }
  }


}
